import type { Translation } from 'primeng/api';

export const TRANSLATION_DE: Translation = {
  accept: 'Ja',
  after: 'Nach',
  addRule: 'Neue Regel',
  apply: 'Übernehmen',
  firstDayOfWeek: 1,
  startsWith: 'Startet mit',
  dayNames: [
    'Sonntag',
    'Montag',
    'Dienstag',
    'Mittwoch',
    'Donnerstag',
    'Freitag',
    'Samstag',
  ],
  dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  today: 'Heute',
  monthNames: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ],
  monthNamesShort: [
    'Jan',
    'Feb',
    'Mär',
    'Apr',
    'Mai',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dez',
  ],
  chooseMonth: 'Monat wählen',
  nextMonth: 'Nächstes Monat',
  prevMonth: 'Vorheriges Monat',
  // Result announcement (aria-live) of autocomplete/cascadeselect, not a
  // "searching…" state; `{0}` is replaced with the number of results.
  searchMessage: 'Ergebnisse verfügbar: {0}',
  emptySearchMessage: 'Keine Ergebnisse gefunden',
  emptyFilterMessage: 'Keine Ergebnisse gefunden',
  // p-tree resolves its empty state via this key (emptySearch/Filter only
  // cover select/multiselect); without it the tree falls back to English.
  emptyMessage: 'Keine Ergebnisse gefunden',
};
